module.exports = __webpack_public_path__ + "img/meat__chalk2.2d0d20d1.png";